module.exports = __webpack_public_path__ + "static/media/seguros-mundial-checkmark.0e15c01a.svg";